export default __webpack_public_path__ + "static/About_us_Objective_Icon4-e3e69c3b740514f7911ebb797d3c30d0.png";